
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqJU4Z1v9RKaOPVvK_4514Tq6AyYb7G1_P0J9QaSHB_qj9YMeta } from "/codebuild/output/src3348330746/src/src/pages/faq.vue?macro=true";
import { default as menuepa3rCx8iJLjieROHnYPuMBnXFu9WR0bwq6YoO6eRsUMeta } from "/codebuild/output/src3348330746/src/src/pages/menu.vue?macro=true";
import { default as indexfRM1tDKh1vKkbwiwbiM9oxsa2PhvwJDfASa75Vh0QlgMeta } from "/codebuild/output/src3348330746/src/src/pages/index.vue?macro=true";
import { default as contacttC9Gdu0oQ6EhgFMR9yBqPC22kZbDeSvomY_USei3VUwMeta } from "/codebuild/output/src3348330746/src/src/pages/contact.vue?macro=true";
import { default as tutorialOVqgGu_45c7u7rNb3qRcVqjO4FYf1JFKdY1845i6gl5YQMeta } from "/codebuild/output/src3348330746/src/src/pages/tutorial.vue?macro=true";
import { default as agreementyA41TEggDQ96oJSWcgeLOrk3a2IEjxg2FZIxK9lICVIMeta } from "/codebuild/output/src3348330746/src/src/pages/agreement.vue?macro=true";
import { default as about_45passT_lXTUEVlQZUd9yotihjlNcUoOIIKPPO5zujzAdrXhcMeta } from "/codebuild/output/src3348330746/src/src/pages/about-pass.vue?macro=true";
import { default as indexif044VOJM6hUprLEoY3aZtF9SPYZOxNEaa_453xcET9w0Meta } from "/codebuild/output/src3348330746/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93GIRiXi1Nsnvr4SCJ2nOpX10oki_fiXcYxJlM8l8w6XMMeta } from "/codebuild/output/src3348330746/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceRlpzBO3xOzw8sIiqYzmdwAmKpRKjsbJpwEo4WTH1TX0Meta } from "/codebuild/output/src3348330746/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93f6BYSUaa6rJG18pnKsJob5Fxw9dF1R9egdxvQrfM9R8Meta } from "/codebuild/output/src3348330746/src/src/pages/notice/[id].vue?macro=true";
import { default as index0_QJ0hXtWRbkJt5Sp2W7t7sTMWuKKagzWWNTzzWHx58Meta } from "/codebuild/output/src3348330746/src/src/pages/coupon/index.vue?macro=true";
import { default as indexMr4eh5N73ozO9WgKNwWM_45jPQxV8_45FWDPJ6eM2_45iOPRQMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/index.vue?macro=true";
import { default as indexxeCSRucQDbqCr1IWJW6HugAb5_45z6BiAKHI9S7CdUmLIMeta } from "/codebuild/output/src3348330746/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_935us9z3WBW4yaB2a2Eo24OAhk0es1bt4TMsU0vSZ6ZIoMeta } from "/codebuild/output/src3348330746/src/src/pages/parking/[id].vue?macro=true";
import { default as indexik96XThvrRqyUHn4yyC8YD1LVoSoXli2zF3SduzN3rEMeta } from "/codebuild/output/src3348330746/src/src/pages/history/index.vue?macro=true";
import { default as index6wtJ_45N8LOBCmJ_0AJGMcb4QySvPlUO7kN8IiKkI4JJYMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/index.vue?macro=true";
import { default as indexnt_45oP7gw9bbnv5tv1hJq9GqoxKsIMm3cyklOdAv8iUMMeta } from "/codebuild/output/src3348330746/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexu8_D16MSbAR8VPJHFcxF9m3rSuimTItING5he0oi0Q0Meta } from "/codebuild/output/src3348330746/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavidjR7X8l4UqJ55sB0I1W9TRfq5L7JIcGicjkPKFTONq0Meta } from "/codebuild/output/src3348330746/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit7lM9FnRnajd_S4pEXx06DDzzU52ZuNab_45pduhoT_AwwMeta } from "/codebuild/output/src3348330746/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementDqXGAqQV8Y6Co7XWTcYQQPVh6GwSOC7RxQpvDhRkHJMMeta } from "/codebuild/output/src3348330746/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexo7PjoEUNOhInO5rmJ6qVdMratFO7dqD6Ud9W5_45TbhqgMeta } from "/codebuild/output/src3348330746/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dfcGjOR9zL3EjOe11eE8ZvSDIH2QjXlMedKj7zKxkQPEMeta } from "/codebuild/output/src3348330746/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmlA25t_45rlj2xbOQvs6pu22OMpqlbRXPtsrD_vA0I65_EMeta } from "/codebuild/output/src3348330746/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexzZSl_45BOir_45urBvbQ1bgFTWMFr0Ib14tNSyv6Qep8UDMMeta } from "/codebuild/output/src3348330746/src/src/pages/card/create/index.vue?macro=true";
import { default as indexmDBKclwARGKbDu2jnJGXPwI5Ywaqv53HIZSUfN79yZAMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmmoPKk3wz8DWWwFOlswjmoYL7Cfji3YBb1Vq4_45JJyOxoMeta } from "/codebuild/output/src3348330746/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmmLPvZCEhhl_45ESW85TDk3ns1YLKqB95AJsnV_xNU4BaUMeta } from "/codebuild/output/src3348330746/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeKjI7uO7qtY9uvtGfhf8BazwmQjUlEVqd_45LI5frZ6ib4Meta } from "/codebuild/output/src3348330746/src/src/pages/membership/complete.vue?macro=true";
import { default as register_45KZbesFm9rIqssEoiEQ7rBTuRXM70NaeA6HYgQiRpIsMeta } from "/codebuild/output/src3348330746/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93Wj1OGdY6jfh_hkVs79gC64HIctw_hd8BGzbpZd3NWkEMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmk0CxBk8Cb7YoQ3SH5YFsInQpCXT8KhVKLW_451_IBAtp8Meta } from "/codebuild/output/src3348330746/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93JQSJj92J9a_1yNViOM__45ojMcVNNom87ydrCfZgU_LkkMeta } from "/codebuild/output/src3348330746/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexnic08kguPIsLzF3zMzdH1LLbNY2bGayU9JB_45sR1CkMcMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code5CBrfsr5VfS4YmeBiwjk3vltrwRCUPfN0gWdQkL1SU8Meta } from "/codebuild/output/src3348330746/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeYBuf6jcFzCbU6WxY6nn7aB80fgkFX40uTxVllhvZLQgMeta } from "/codebuild/output/src3348330746/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeCY5MC_nJ0ekbahg9htS9DeEHbS3C3ypYD_fp4AFEilgMeta } from "/codebuild/output/src3348330746/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerx6NmZn5wnQRR9kFE3YFmVHTr1FvuZw1juXg_45vpJpSfYMeta } from "/codebuild/output/src3348330746/src/src/pages/contact-form/register.vue?macro=true";
import { default as completexMM5hoDEWXoi0Pr3p_g1_ot7HfWqo8HDoJA_45EPv3IIIMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexdCKKFhLCsl_45AmnCnFhO8gLcWFXGaHLreYo19DMeDNugMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmEZi8v0_G8wqHU2qRKbAJWHMOyzoyhbcP5oBtVYGt4ccMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completefzP7Bo28VOr1GLB8r07v8swu8LJ0KpWFc8sAOgkeTbsMeta } from "/codebuild/output/src3348330746/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexYml5zvnZzGiEX4ItIdUdKWlDBzrxg5MZt4BPt0IYXLkMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93mPlY5S9cJYf4264pjyTVx_3BDHTN3EPXkPoWAWuawBkMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completetCfB_45YnoWXIlMeITvznmr73VjxkOHkYpNIgoL_3hDtkMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasEci8xUkjEmXpFWVJB8JgbdMM89r4Ap_45bOE3A6ik9z0oMeta } from "/codebuild/output/src3348330746/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleTUGIn3BHsaOROrLnylZ3mVfyJcJC_yY1xQkRPiqMOU0Meta } from "/codebuild/output/src3348330746/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailQ0_45dDBEkPGl4UFOdDKdeHkR8XhxxKv7iuVqoMzu4zwoMeta } from "/codebuild/output/src3348330746/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm5Eku1zdLXFNySyWiQyo2TPhnYZVL5echyEbwVa1IG88Meta } from "/codebuild/output/src3348330746/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentHBEzJijJCRGHSLG4de9xNDOtHrG6C0Kuk3B1Xvg_455AYMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmOdsgebciSQRBS6sJynbeG8Qfi__kehArL81waM4ul8kMeta } from "/codebuild/output/src3348330746/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatesw08JRF1JYmvj_45pTEasTY6h_yWZloi2lJQ4JMf5a1ZUMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete111WRDshztk8UGfmC_45m0F1wrt2g68szgRa9U5SGVuYUMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code7CnoQgLTQYVu33qGy2tYJq81g8B5T8er3_45xRs4RB67gMeta } from "/codebuild/output/src3348330746/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordsruZwKKG7WHUro_Qos6UqiavY4TFQbPJcQ705i1Sw8cMeta } from "/codebuild/output/src3348330746/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasM_pSWpe_45Tlx1LC8a1QG4ovUiqpuqFyBzjz_45OEHbYtNMMeta } from "/codebuild/output/src3348330746/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerhxw2yjaR_453uSdj4IDYaqVhUddZY0Q_45LFibszINGUkCEMeta } from "/codebuild/output/src3348330746/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeFCdR7IxsJsvpxMZ_45RP6WVma_45B_45lpI7ZSopIMOiUgORUMeta } from "/codebuild/output/src3348330746/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexmIqjzhgE2frPWEpW2_Wgf_L3k9YYuL_45GC_AanZYdi_45IMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexWRMznzXbQW1yKi9oal39moJ1GEZWqmkrMk7JZYiERVsMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexFaDDmf6ZOt_lDz_45_Qy9QH1_GLKacpvIloqUUgzA55bUMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexp7MLkXojyhIYiEf_45iPFHixnPZj9ypTgf4LSn8UJFj8gMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateFVDtZCzn1QXNK0kSuHbtkVpkoD6oi53BWbZDsNFci34Meta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeAK3a4B_45vIgliuqzjePd5cn5US9mAg3ioZTY5k46fNH0Meta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm9HfhVik3jyQWR1AF8emV9N5kfQq6CZ_45O3m3p_45mp6gcgMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexrqw5Bny8B91NJRxKidkoyvUlAl16mRarHRo1Aw_454YuoMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeNv336p7lCtCTCWvML5nQGOxsJHczkofD6VA0uPbQyCgMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateceZ_45_DzDzkldtORC8MzXOEX_45vU3dCDJcZFVaE2x64TsMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index0z4X69DPGB1DuBU6ZS1CbbY_45dNLPSEEOCsF_hJhmVn4Meta } from "/codebuild/output/src3348330746/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexOjZF_45GbxbwcDxGBsehqYXIjI2XlecwSlotv2XSguzzkMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeq8maYBNrwE8BuES00983YRZ7rqeZ_45bE_45ufWSZdSmcPQMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexugZFm85ESQ0SYgFrip_45lCWFxKLVECm31HwWc2_g8yWgMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codejlFleTPctQl_45DO3gxWRfCpZGWa_blAs_45iW2vwfgwArcMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index_45G6oPVBNg3Us59P_45aefILowphvt5DMb7ZQwGCKf_45E50Meta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexkUJtUeAyl2EFgw8aGlXdo_rxioxOFMA0R78PopCpw90Meta } from "/codebuild/output/src3348330746/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexsAGXOcOz7ayjD7sGN4Mbn_45zPd6ubwl6g0yKgnr3l2tYMeta } from "/codebuild/output/src3348330746/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateKBVCDhCe7PgfBl7NSO6vQnLMB7VvAwynHulZKglCzfwMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmD0LkzAyR8bDH73auTNlRWby7waigtGcfqYd4v75DVMsMeta } from "/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuepa3rCx8iJLjieROHnYPuMBnXFu9WR0bwq6YoO6eRsUMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexfRM1tDKh1vKkbwiwbiM9oxsa2PhvwJDfASa75Vh0QlgMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index0_QJ0hXtWRbkJt5Sp2W7t7sTMWuKKagzWWNTzzWHx58Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexik96XThvrRqyUHn4yyC8YD1LVoSoXli2zF3SduzN3rEMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexnt_45oP7gw9bbnv5tv1hJq9GqoxKsIMm3cyklOdAv8iUMMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexu8_D16MSbAR8VPJHFcxF9m3rSuimTItING5he0oi0Q0Meta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexzZSl_45BOir_45urBvbQ1bgFTWMFr0Ib14tNSyv6Qep8UDMMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmmoPKk3wz8DWWwFOlswjmoYL7Cfji3YBb1Vq4_45JJyOxoMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmmLPvZCEhhl_45ESW85TDk3ns1YLKqB95AJsnV_xNU4BaUMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeKjI7uO7qtY9uvtGfhf8BazwmQjUlEVqd_45LI5frZ6ib4Meta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register_45KZbesFm9rIqssEoiEQ7rBTuRXM70NaeA6HYgQiRpIsMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmk0CxBk8Cb7YoQ3SH5YFsInQpCXT8KhVKLW_451_IBAtp8Meta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code5CBrfsr5VfS4YmeBiwjk3vltrwRCUPfN0gWdQkL1SU8Meta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeYBuf6jcFzCbU6WxY6nn7aB80fgkFX40uTxVllhvZLQgMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeCY5MC_nJ0ekbahg9htS9DeEHbS3C3ypYD_fp4AFEilgMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerx6NmZn5wnQRR9kFE3YFmVHTr1FvuZw1juXg_45vpJpSfYMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmEZi8v0_G8wqHU2qRKbAJWHMOyzoyhbcP5oBtVYGt4ccMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completefzP7Bo28VOr1GLB8r07v8swu8LJ0KpWFc8sAOgkeTbsMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexYml5zvnZzGiEX4ItIdUdKWlDBzrxg5MZt4BPt0IYXLkMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completetCfB_45YnoWXIlMeITvznmr73VjxkOHkYpNIgoL_3hDtkMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleTUGIn3BHsaOROrLnylZ3mVfyJcJC_yY1xQkRPiqMOU0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailQ0_45dDBEkPGl4UFOdDKdeHkR8XhxxKv7iuVqoMzu4zwoMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm5Eku1zdLXFNySyWiQyo2TPhnYZVL5echyEbwVa1IG88Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentHBEzJijJCRGHSLG4de9xNDOtHrG6C0Kuk3B1Xvg_455AYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmOdsgebciSQRBS6sJynbeG8Qfi__kehArL81waM4ul8kMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete111WRDshztk8UGfmC_45m0F1wrt2g68szgRa9U5SGVuYUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code7CnoQgLTQYVu33qGy2tYJq81g8B5T8er3_45xRs4RB67gMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordsruZwKKG7WHUro_Qos6UqiavY4TFQbPJcQ705i1Sw8cMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerhxw2yjaR_453uSdj4IDYaqVhUddZY0Q_45LFibszINGUkCEMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeFCdR7IxsJsvpxMZ_45RP6WVma_45B_45lpI7ZSopIMOiUgORUMeta || {},
    component: () => import("/codebuild/output/src3348330746/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3348330746/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]